import { render, staticRenderFns } from "./ownership.vue?vue&type=template&id=e6b6f192&scoped=true&"
import script from "./ownership.vue?vue&type=script&lang=js&"
export * from "./ownership.vue?vue&type=script&lang=js&"
import style0 from "./ownership.vue?vue&type=style&index=0&id=e6b6f192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b6f192",
  null
  
)

export default component.exports